import React from "react";
import './NewContactsIcon.scss';

const NewContactsIcon = ({ count }) => {
  return (
    <span className="badge badge-primary NewContactsIcon__container">
      {count}
    </span>
  );
};

export default NewContactsIcon;



// WEBPACK FOOTER //
// ./src/components/NewContactsIcon/NewContactsIcon.jsx